import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      Loading...
    </div>
  );
};

export default LoadingScreen;
